// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".select-empty[data-v-2707f202]{height:52px;border:1.5px solid #e8e9eb;border-radius:8px;padding:0 15px;background-color:#fff;color:#606266;font-size:14px;width:100%;margin-bottom:17px;display:flex;align-items:center;justify-content:flex-start;user-select:none;cursor:default}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
